<ng-progress></ng-progress>
<router-outlet></router-outlet>